<template>
  <div>
    <div id="notfound-container" v-if="checkMobileStatus">
      <div class="notFoundPanel">
        <h1>Download EtonHouse Parent App</h1>
        <div class="marketWidget">
          <img :src="assets.image.appStore" class="mb-3" @click="loadAppStore" />
          <img :src="assets.image.playStore" @click="loadPlayStore" />
        </div>
        <div class="notfound-img">
          <img :src="assets.image.appMobileLanding" />
        </div>
      </div>
    </div>

    <div id="notfound-container" v-else>
      <div class="notFoundPanel">
        <div class="notfound-img">
          <img :src="assets.image.appLanding" />
          <div class="parentApp-left-content">
            <img :src="assets.image.appLandingLogo" class="mb-3" />
            <div class="marketWidget">
              <img :src="assets.image.appStore" class="mb-3" @click="loadAppStore" />
              <img :src="assets.image.playStore" @click="loadPlayStore" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import assets from '@/assets/assets'
import './notFound.scss'

export default {
  name: 'ParentNotFoundPage',
  data() {
    return {
      assets: assets,
      token: null,
      userType: null,
      list: [],
      results: '',
      checkMobileStatus: false,
    }
  },
  created() {
    window.addEventListener('resize', this.isMobile)
  },
  destroyed() {
    window.removeEventListener('resize', this.isMobile)
  },
  async mounted() {
    this.isMobile()
  },
  methods: {
    isMobile() {
      let screenWidth = window.innerWidth
      if (screenWidth <= 770) {
        this.checkMobileStatus = true
        document.body.classList.add('notFoundMobileView')
        // return true;
      } else {
        this.checkMobileStatus = false
        document.body.classList.add('notFoundParent')
        // return false;
      }
    },
    loadAppStore() {
      window.open('https://apps.apple.com/us/app/etonhouse-parents/id6443718169', '_blank')
    },
    loadPlayStore() {
      window.open('https://play.google.com/store/apps/details?id=sg.etonhouse.mobile.parent', '_blank')
    },
  },
}
</script>
